<ng-container [formGroup]="group">
  <mat-slider
    #matSlider
    [color]="model.getAdditional('color', 'accent')"
    [formControlName]="model.id"
    [id]="id"
    [min]="model.min"
    [max]="model.max"
    [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
    [step]="model.step"
    [tabIndex]="model.tabIndex"
    [discrete]="model.getAdditional('discrete', true)"
    [showTickMarks]="model.getAdditional('tickInterval', 1)"
    (change)="onChange($event)"
    (input)="onCustomEvent($event, 'input')"
    [invert]="model.getAdditional('invert', false)"
    [vertical]="model.vertical"
  ></mat-slider>
</ng-container>

<!-- [invert]="model.getAdditional('invert', false)"  [vertical]="model.vertical"
  Angular Material 15 to 17 Note: (DO NOT REMOVE / FUTURE REFERENCE)
  Vertical sliders and inverted sliders are no longer supported, as they are no longer part of the Material Design spec. 
  As a result, the invert and vertical properties have been removed.
  Reference: https://v16.material.angular.io/guide/mdc-migration -->
